import React, { useState } from "react";
import { Button, Col, Form, Row, Badge } from "react-bootstrap";
import Price from "../assets/price.png";
import Footer from "../components/Footer";
import Comming from "../assets/comming.png";
import { Post } from "../payment/PaymentPost";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Subscription = () => {
  const navigate = useNavigate();
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  const user = useSelector((state) => state.user.user);
  const getData = (data) => {
    return fetch(`https://htacademy.in/api/v1/payment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((err) => console.log(err));
  };
  const basicPlan = () => {
    if (isLogged) {
      let amount = 199;
      getData({
        amount: amount,
        email: user[0].email,
        mobile: user[0].phone,
        name: user[0].name,
        total: 0,
        course: "Full Stack Web Development",
      }).then((response) => {
        var information = {
          action: "https://securegw.paytm.in/theia/processTransaction",
          params: response,
        };
        Post(information);
      });
    } else {
      navigate("/login");
    }
  };
  const goldPlan = () => {
    if (isLogged) {
      let amount = 399;
      getData({
        amount: amount,
        email: user[0].email,
        mobile: user[0].phone,
        name: user[0].name,
        total: 0,
        course: "Full Stack Web Development",
      }).then((response) => {
        var information = {
          action: "https://securegw.paytm.in/theia/processTransaction",
          params: response,
        };
        Post(information);
      });
    } else {
      navigate("/login");
    }
  };

  const diamondPlan = () => {
    if (isLogged) {
      let amount = 599;
      getData({
        amount: amount,
        email: user[0].email,
        mobile: user[0].phone,
        name: user[0].name,
        total: 0,
        course: "Full Stack Web Development",
      }).then((response) => {
        var information = {
          action: "https://securegw.paytm.in/theia/processTransaction",
          params: response,
        };
        Post(information);
      });
    } else {
      navigate("/login");
    }
  };
  return (
    <>
      <Row className="mx-0 py-3 bg-pricing">
        <Col>
          <h3 className="text-center">
            Get a comprehensive Subscription Plans
          </h3>
          <h6 className="text-center">
            Become a Priority Candidate by highlighting yourself and to increase
            your chances of getting a job
          </h6>
        </Col>
      </Row>
      <Row className="mx-0 mt-1 px-5">
        <Col md={4}></Col>
        <Col md={4}>
          <Row className="">
            <Col>
              <h5 className="mb-0 py-2 text-center">
                {/* <Button variant="primary" className="rounded-pill px-4 me-1">
                  3 Month's
                </Button>
                <Button
                  variant="outline-success"
                  className="rounded-pill px-4 me-1"
                >
                  6 Month's
                </Button> */}
                <Button variant="success" className="rounded-pill px-4">
                  12 Month's
                </Button>
              </h5>
            </Col>
          </Row>
        </Col>
        <Col md={4}></Col>
      </Row>
      <Row className="mx-0 mb-4 px-5">
        <Col md={1}></Col>
        <Col md={10} className="">
          <Row className="pb-2">
            <Col md={5} className="shadow bg-price rounded-start">
              <h4 className=" p-3 pt-5">
                Benefits of Subscription Services{" "}
                <img src={Price} alt="Price" className="float-end opacity-50" />
              </h4>
              <p>
                <ul className="price-bill pb-2">
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Get up to 75% off on course fee
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Daily quiz
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Daily problem solving compare
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Get MCQ tests - per month
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Interview Q & A
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Mock Interviews - per month
                  </li>
                  <li>
                    <i className="fas fa-long-arrow-alt-right text-secondary fw-bold"></i>{" "}
                    &nbsp; Resume Preparation Guidance
                  </li>
                </ul>
              </p>
            </Col>
            <Col md={7}>
              <Row>
                <Col md={4} className="shadow bg-white">
                  <h5 className="text-center mb-0 pb-1 mt-3">
                    <Badge bg="warning" text="dark" className="px-3">
                      Basic
                    </Badge>
                  </h5>
                  <h4 className=" text-center">
                    <span>
                      <i className="fa fa-rupee"></i>&nbsp;199*{" "}
                      <small className="sm-price">
                        <strike>
                          <i className="fa fa-rupee"></i>&nbsp;299*
                        </strike>
                      </small>
                    </span>
                  </h4>
                  <p className="sm-tax text-center">&nbsp;</p>
                  <ul className="price-high pb-2 text-center">
                    <li>
                      <span className="text-secondary fw-bold fs-6">
                        up to 25%
                      </span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-times-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <span className="text-secondary fw-bold fs-6">1</span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-times-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-times-circle text-secondary fw-bold fs-5"></i>
                    </li>
                  </ul>
                  <p className="text-center fs-6">
                    <Button variant="danger px-5" onClick={basicPlan}>
                      Buy Now
                    </Button>
                  </p>
                </Col>
                <Col md={4} className="shadow bg-sub">
                  <h5 className="text-center mb-0 pb-1 mt-3">
                    <Badge bg="success" className="px-3">
                      Gold
                    </Badge>
                  </h5>
                  <h4 className=" text-center">
                    <span>
                      <i className="fa fa-rupee"></i>&nbsp;399*{" "}
                      <small className="sm-price">
                        <strike>
                          <i className="fa fa-rupee"></i>&nbsp;599*
                        </strike>
                      </small>
                    </span>
                  </h4>
                  <p className="sm-tax text-center">&nbsp;</p>
                  <ul className="price-high pb-2 text-center">
                    <li>
                      <span className="text-secondary fw-bold fs-6">
                        up to 50%
                      </span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <span className="text-secondary fw-bold fs-6">3</span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-times-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-times-circle text-secondary fw-bold fs-5"></i>
                    </li>
                  </ul>
                  <p className="text-center">
                    <Button variant="danger px-5" onClick={goldPlan}>
                      Buy Now
                    </Button>
                  </p>
                </Col>
                <Col md={4} className="shadow bg-sub1 rounded-end">
                  <h5 className="text-center mb-0 pb-1 mt-3">
                    <Badge bg="danger" className="px-3">
                      Daimond
                    </Badge>
                  </h5>
                  <h4 className=" text-center">
                    <span>
                      <i className="fa fa-rupee"></i>&nbsp;599*{" "}
                      <small className="sm-price">
                        <strike>
                          <i className="fa fa-rupee"></i>&nbsp;999*
                        </strike>
                      </small>
                    </span>
                  </h4>
                  <p className="sm-tax text-center">&nbsp;</p>
                  <ul className="price-high pb-2 text-center">
                    <li>
                      <span className="text-secondary fw-bold fs-6">
                        up to 75%
                      </span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <span className="text-secondary fw-bold fs-6">5</span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                    <li>
                      <span className="text-secondary fw-bold fs-6">1</span>
                    </li>
                    <li>
                      <i className="far fa-check-circle text-secondary fw-bold fs-5"></i>
                    </li>
                  </ul>
                  <p className="text-center">
                    <Button variant="danger px-5" onClick={diamondPlan}>
                      Buy Now
                    </Button>
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={1}></Col>
      </Row>
      {/* <Row className="mx-0 stud-test py-3">
        <Col className="text-center">
          <img src={Comming} alt="" className="img-fluid" />
        </Col>
      </Row> */}
      <Footer />
    </>
  );
};

export default Subscription;
